// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconWaveform } from '@ni/nimble-components/dist/esm/icons/waveform';
import { wrap } from '../utilities/react-wrapper';

export { type IconWaveform };
export const NimbleIconWaveform = wrap(IconWaveform);